export default __webpack_public_path__ + "static/media/essential-icon.96121ebb.svg";